import { FC } from 'react';
import { Close } from '@clds/icon';
import { HorizontalSeparator } from '@clds/separator';
import { Button } from '@clds/button';
import { MobileMenuHeaderProps } from './DropdownMobileMenu.types';
import { StyledMobileMenuHeader } from './DropdownMobileMenu.styled';

export const MobileMenuHeader: FC<MobileMenuHeaderProps> = ({ headerTitle, onClose }) => (
  <>
    <StyledMobileMenuHeader>
      {headerTitle}
      <Button size="sm" tone="plain" variant="secondary" leftSlot={<Close color="contrastHigh" size="md" />} onClick={onClose} />
    </StyledMobileMenuHeader>
    <HorizontalSeparator />
  </>
);
